import { shoppingBasketResponseFragment } from '#src/clientState/fragments/shoppingBasketResponse.fragments';
import { gql } from '@edreamsodigeo/frontend-api-client';

export const GET_UNIVERSAL_SHOPPING_BASKET = gql`
  query SB_GetUniversalShoppingBasket(
    $request: UniversalShoppingBasketRequest!
  ) {
    getUniversalShoppingBasket(request: $request) {
      ...UniversalShoppingBasketResponseFields
    }
  }
  ${shoppingBasketResponseFragment}
`;

export const GET_UNIVERSAL_SHOPPING_BASKET_BY_TOKEN = gql`
  query SB_GetUniversalShoppingBasketByToken(
    $request: UniversalShoppingBasketByTokenRequest!
  ) {
    getUniversalShoppingBasketByToken(request: $request) {
      ...UniversalShoppingBasketResponseFields
    }
  }
  ${shoppingBasketResponseFragment}
`;
